import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { http, track } from "@/advisor/api";
import { toast } from "sonner";
import { metaAdvisorResult } from "@/lib/meta";

const STEPS = ["Biznes növü müəyyən edildi", "Məqsədlər analiz edildi", "Uyğun həllər seçilir", "Tövsiyələr hazırdır"];

export const Analyzing = ({ onDone, onFail }) => {
  const { state, update } = useAdvisor();
  const [done, setDone] = useState(0);
  const ran = useRef(false);

  useEffect(() => {
    const timer = setInterval(() => setDone((d) => Math.min(d + 1, STEPS.length)), 750);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const goals = state.business?.key === "tiktok" ? state.tiktokGames : state.goals;
    const req = http.post("/advisor/recommend", {
      business_text: state.businessText, business_type: state.business?.key, goals, tools: state.tools,
    });
    Promise.all([req, new Promise((r) => setTimeout(r, 3200))])
      .then(([res]) => {
        update({ recommendations: res.data.solutions });
        track("recommendations", { business_type: state.business?.key });
        metaAdvisorResult(state.business?.key, res.data.solutions.length);
        onDone();
      })
      .catch(() => {
        toast.error("Xəta baş verdi. Yenidən cəhd edin.");
        onFail();
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="adv-card p-6 sm:p-10 relative overflow-hidden" data-testid="analysis-loader-container">
      <div className="absolute inset-0 adv-grid opacity-60" />
      <div className="absolute inset-x-0 h-px bg-[#D6AD62]/70 shadow-[0_0_20px_#D6AD62] adv-scan" />
      <div className="relative">
        <div className="h-14 w-14 rounded-2xl bg-[#D6AD62]/15 grid place-items-center mb-5">
          <Loader2 className="h-7 w-7 text-[#F3D592] animate-spin" />
        </div>
        <h3 className="text-2xl sm:text-3xl font-bold">Biznesinizi analiz edirik...</h3>
        <ul className="mt-6 space-y-3">
          {STEPS.map((s, i) => (
            <motion.li
              key={s}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: i < done ? 1 : 0.3, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className="flex items-center gap-3"
              data-testid={`analysis-step-${i}`}
            >
              <span className={`h-7 w-7 rounded-full grid place-items-center ${i < done ? "bg-emerald-400 text-[#111110]" : "bg-white/5"}`}>
                {i < done ? <Check className="h-4 w-4" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#8b867c]" />}
              </span>
              <span className={i < done ? "text-[#F3EEE4]" : "text-[#8b867c]"}>{s}</span>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
};
